import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/form/index.js
// module id = 680
// module chunks = 1